import { render, staticRenderFns } from "./PpmCalcParent.vue?vue&type=template&id=3cc54237&"
import script from "./PpmCalcParent.vue?vue&type=script&lang=js&"
export * from "./PpmCalcParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports